/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Dlsg supported file extensions.
*/
export enum DlsgFileExtension {
  Parquet = 'parquet',
  Avro = 'avro',
  Orc = 'orc',
  Json = 'json',
  Csv = 'csv',
  Txt = 'txt',
  FileExtensionUnspecified = 'FILE_EXTENSION_UNSPECIFIED'
}
